import { contains } from './contains';
export function handleMouseProxy(related, handler) {
  return evt => {
    const target = evt.currentTarget;
    const relatedTarget = evt.relatedTarget || evt.nativeEvent[related];
    if ((!relatedTarget || related !== relatedTarget) && !contains(target, relatedTarget)) {
      handler();
    }
  };
}